module.exports = __webpack_public_path__ + "img/84.be2122d4.png";